import { IProductDataV2, IProductDataV3 } from '@df/catalog/product/product';
import { ProductDecorator } from '../../model/product/product.decorator';

export enum WishlistStatus {
    BeforeAdd = 'beforeAdd',
    AddSuccess = 'addSuccess',
    RemoveSuccess = 'removeSuccess',
    Already = 'already'
}

export class WishlistEvent {
    constructor(
        public product: ProductDecorator<IProductDataV2 | IProductDataV3>,
        public status: WishlistStatus,
        public callback?: () => void,
        public index?: number
    ) {}
}
